const stripTypenames = (value) => {
  if (Array.isArray(value)) {
    return value.map(stripTypenames)
  } else if (value !== null && typeof (value) === "object") {
    const newObject = {};
    for (const property in value) {
      if (property !== '__typename') {
        newObject[property] = stripTypenames(value[property])
      }
    }
    return newObject
  } else {
    return value
  }
};

function isObject(A) {
  return (typeof A === "object" || typeof A === 'function') && (A !== null);
}

function isMobile() {
  return !!(navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i))
    && window.innerWidth < 820;
}

export {
  stripTypenames,
  isObject,
  isMobile
}
